import Vue from"vue";Vue.filter("truncate",(function(t,e){return t.length>e?t.substring(0,e)+"...":t}));